import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { Button, rem } from 'design-system';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import useStyles from 'hooks/useStyles';
import { useTabNavigation } from 'hooks/navigation/useTabNavigation';
import createStyleSheets from 'utils/createStyleSheets';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../constants';
const UnopenedInvestmentAccountItem = ({ data }) => {
    const { investAccountName } = data;
    const styles = useStyles(styleSet);
    const { navigateToTab } = useTabNavigation();
    const onPress = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://invest/account', 'Set up investment account');
            return;
        }
        navigateToTab('Invest');
    }, []);
    return (<View style={styles.container}>
      <IconEmmaWallet />
      <View style={styles.flex}>
        <Text Text-16 numberOfLines={1}>
          {investAccountName}
        </Text>
      </View>
      <Button square hug onPress={onPress} brandReversed title="Set up"/>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        gap: rem(16),
        padding: rem(16),
        flexDirection: 'row',
        alignItems: 'center',
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
    flex: {
        flex: 1,
    },
}));
export default memo(UnopenedInvestmentAccountItem);
